// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"ee1d0aa4","330":"87ec51cd","453":"0e6ead16","598":"737ab385","624":"0122ba3c","635":"ad96348e","827":"fdc7a3e3","970":"c69848c1"}[chunkId] + ".chunk.js";
};